import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cn from '../../../utils/tools/cn';

// Icons
import { ReactComponent as ChevronDown } from '../../../assets/icons/chevron_down.svg';

// Components
import Tag from '../Tag/Tag';

import styles from './TagWithEdition.module.scss';

function TagWithEdition({
  theme, label, options, onChange, disabled, activeValue, rightAlign, big,
}) {
  const ref = useRef();

  const [isOpened, setIsOpened] = useState(false);

  const handleClickOutside = (e) => {
    if (ref?.current && !ref.current.contains(e.target)) {
      setIsOpened(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleChange = (value) => {
    if (activeValue && activeValue !== value) {
      onChange(value);
      setIsOpened(false);
    }
  };

  return (
    <div className="d-flex">
      <div
        ref={ref}
        className={cn([
          styles.wrapper,
          'd-flex',
          rightAlign ? 'j-end' : '',
        ])}
      >
        <button
          type="button"
          onClick={() => setIsOpened(!isOpened)}
          className={styles.active_tag}
          disabled={disabled}
        >
          <Tag
            theme={theme}
            label={(
              <div className="d-flex a-center c-pointer font-secondary fs-14 fw-500">
                {label}
                <ChevronDown width={12} height={6} className="m-l-10" />
              </div>
            )}
            big={big}
          />
        </button>

        <div
          className={cn([
            styles.dropdown,
            isOpened ? styles.opened : '',
            !rightAlign ? styles.left_align : '',
          ])}
        >
          <div className={styles.dropdown_inner}>
            {options?.map((option, i) => (
              <button
                type="button"
                key={i}
                onClick={() => handleChange(option.value)}
                className={cn([
                  styles.option,
                  'c-pointer',
                  option.value === activeValue ? styles.active : '',
                ])}
                disabled={disabled}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

TagWithEdition.propTypes = {
  theme: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  activeValue: PropTypes.string,
  rightAlign: PropTypes.bool,
  big: PropTypes.bool,
};

TagWithEdition.defaultProps = {
  theme: null,
  label: null,
  options: [],
  onChange: () => {},
  disabled: false,
  activeValue: null,
  rightAlign: false,
  big: false,
};

export default TagWithEdition;
